import { Instagram, Linkedin, ArrowUp } from "lucide-react";

export default function Footer() {
  return (
    <footer className="relative border-t border-[#22222B] bg-[#08080A] pt-20 pb-10 overflow-hidden" data-testid="footer">
      <div className="max-w-7xl mx-auto px-5 sm:px-8">
        <div className="flex flex-col lg:flex-row justify-between gap-12 mb-16">
          <div>
            <img
              src="/assets/seal.jpg"
              alt="Plagiarhythm official seal — Records of San Diego, MMVI"
              loading="lazy"
              className="h-24 w-24 rounded-full object-cover border border-[#22222B] mb-6"
              data-testid="footer-seal"
            />
            <p className="font-display uppercase text-5xl sm:text-7xl leading-none text-[#F2F2F5]" data-testid="footer-wordmark">
              PLAGIA<span className="text-[#00F0FF]">RHYTHM</span>
            </p>
            <p className="mono text-[10px] tracking-[0.35em] text-[#60606E] mt-4">
              RECORDS OF SAN DIEGO // EST. MMVI // WHERE CHAOS MEETS DATA
            </p>
          </div>

          <div className="flex flex-col gap-4 lg:items-end">
            <a
              href="https://instagram.com/plagiarhythm_llc"
              target="_blank"
              rel="noopener noreferrer"
              className="flex items-center gap-3 mono text-[11px] tracking-[0.25em] text-[#A0A0AB] hover:text-[#00F0FF] transition-colors duration-300"
              data-testid="footer-instagram-link"
            >
              <Instagram className="h-4 w-4" /> @PLAGIARHYTHM_LLC
            </a>
            <a
              href="https://www.linkedin.com/in/aandrbeast"
              target="_blank"
              rel="noopener noreferrer"
              className="flex items-center gap-3 mono text-[11px] tracking-[0.25em] text-[#A0A0AB] hover:text-[#00F0FF] transition-colors duration-300"
              data-testid="footer-linkedin-link"
            >
              <Linkedin className="h-4 w-4" /> /IN/AANDRBEAST
            </a>
            <a
              href="mailto:ryan@plagiarhythm.com"
              className="flex items-center gap-3 mono text-[11px] tracking-[0.25em] text-[#A0A0AB] hover:text-[#00F0FF] transition-colors duration-300"
              data-testid="footer-email-link"
            >
              RYAN@PLAGIARHYTHM.COM
            </a>
            <a
              href="tel:+16195869291"
              className="flex items-center gap-3 mono text-[11px] tracking-[0.25em] text-[#A0A0AB] hover:text-[#00F0FF] transition-colors duration-300"
              data-testid="footer-phone-link"
            >
              (619) 586-9291
            </a>
            <a
              href="#top"
              className="flex items-center gap-3 mono text-[11px] tracking-[0.25em] text-[#A0A0AB] hover:text-[#CCFF00] transition-colors duration-300 mt-4"
              data-testid="footer-back-to-top"
            >
              <ArrowUp className="h-4 w-4" /> BACK TO TOP
            </a>
          </div>
        </div>

        <div className="border-t border-[#22222B] pt-8 flex flex-col sm:flex-row justify-between gap-4">
          <p className="mono text-[10px] tracking-[0.2em] text-[#60606E]">
            © {new Date().getFullYear()} PLAGIARHYTHM LLC. ALL RIGHTS RESERVED.
          </p>
          <p className="mono text-[10px] tracking-[0.2em] text-[#60606E]">
            “WE LOVE THIS LIFE AND WE AIN'T PERFECT BUT WE GETTING THERE.”
          </p>
        </div>
      </div>
    </footer>
  );
}
